import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import {
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableFooter,
    Paper,
} from '@mui/material';
import Select from 'react-select';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import PrintIcon from '@mui/icons-material/Print';
import Info from '@mui/icons-material/Info';
import ReactDOM from 'react-dom';
import RefreshIcon from '@mui/icons-material/Refresh';
import AddIcon from '@mui/icons-material/Add';

function SaleReturnReport() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const history = useHistory(); // Access the navigation history
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [routeOptions, setRouteOptions] = useState([]);
    const [selectedRoute, setSelectedRoute] = useState(null);

    const { isAuthenticated, companyId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Transaction');
    const hasEditMasterPermission = permissions.includes('Edit Transaction');
    const hasDeleteMasterPermission = permissions.includes('Delete Transaction');
    const branchId = 0;
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

        // Token is not expired, fetch data
        setFromDate(getMonthStartDate());
        setToDate(getFormattedCurrentDate());
        //fetchTableData();
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getMonthStartDate = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Ensure 2-digit month
        return `${year}-${month}-01`; // Format as 'YYYY-MM-DD'
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };


    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };
    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );


    useEffect(() => {
        fetchRouteTypes();
    }, []);

    const fetchRouteTypes = async () => {
        try {
            const response = await fetchData('RouteApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(route => ({
                    value: route.id,
                    label: route.name
                }));
                setRouteOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }

    };
    const handleRouteTypeChange = async (selectedOption) => {
        setSelectedRoute(selectedOption);

        setData([]);
        try {


            const response = await fetchData('SalesReportAPI', `/${companyId}/${selectedOption.value}/${fromDate}/${toDate}`, token);
            if (response.responseCode === '1111') {
                setData(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Customer Details:', error);
            if (error.response && error.response.status === 401) {
                logout();
                history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
            }
        }

    };

    const handleDelete = async () => {
        deleteData('SalesReportAPI', `${deleteItemId}`, token)
            .then((response) => {
                //s fetchTableData();
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {

                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('SaleApi', `${itemId}`, token)
            .then(() => {
                //fetchTableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }

    const calculateTotals = (data) => {
        const totalAmount = data.reduce((sum, row) => sum + row.Amount, 0);
        const grandTotal = data.reduce((sum, row) => sum + row.TotalAmount, 0);
        return { totalAmount, grandTotal };
    };
    const handleRefreshClick = () => {

        // setToDate(getCurrentDate());
        // fetchData();
        window.location.reload();
    };

    const { totalAmount, grandTotal } = calculateTotals(filteredData);

    return (
        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>

            <div className='w-full mb-2 flex'>
                <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Sales Return Summary </h6>
                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>

                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '300px' : '200px',
                            height: '40px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                            marginTop: '20px'
                        }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        FromDate
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        ToDate
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>

                {/* Route */}
                <div className="flex flex-col space-y-1" >
                    <label className="block text-black text-sm " htmlFor="salesmanSelect" style={{ fontSize: '14px' }}>
                        Route
                    </label>
                    <Select
                        value={selectedRoute}
                        onChange={handleRouteTypeChange}
                        options={[
                            { value: 0, label: "All Route" },
                            ...routeOptions
                        ]}
                        placeholder="Select Trip"
                        isSearchable
                        className="w-40"
                    />
                </div>
                <Button
                    style={{ color: "black", height: '36px', marginLeft: '10px', marginTop: '20px' }}
                    onClick={handleRefreshClick}
                    className="linkcolor"
                >
                    <IconButton onClick={handleRefreshClick}>
                        <RefreshIcon style={{ color: 'brown' }} />
                    </IconButton>
                    <span style={{ color: 'brown', fontWeight: 'bolder', marginTop: '-5px' }}>Refresh</span>
                </Button>




            </div>

            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto', marginTop: '-10px' }}>
                <TableContainer component={Paper}>
                    <Table>
                        {/* <TableHead sx={{ backgroundColor: '#58A5B3' }}> */}
                        <TableHead sx={{ backgroundColor: 'teal' }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '3px', color: 'whitesmoke', width: '2%' }}>Sl.No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '3px', color: 'whitesmoke', width: '5%' }}>Customer Name</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '3px', color: 'whitesmoke', width: '5%' }}>Bill Number</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '3px', color: 'whitesmoke', width: '5%' }}>Return Date</TableCell>
                                {/* <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '3px', color: 'whitesmoke', textAlign: 'left', width: '5%' }}>Return Amount</TableCell> */}
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '3px', color: 'whitesmoke', textAlign: 'left', width: '5%' }}>Remark</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '3px', color: 'whitesmoke', textAlign: 'right', width: '5%' }}>Return Amount</TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredData.map((row, index) => (
                                <TableRow key={row.Id}>
                                    <TableCell sx={{ padding: '3px' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ padding: '3px' }}>{row.CustomerName}</TableCell>
                                    <TableCell sx={{ padding: '3px' }}>{row.BillNumber}</TableCell>
                                    <TableCell sx={{ padding: '3px' }}>{formatDate(row.SaleReturndate)}</TableCell>
                                    {/* <TableCell sx={{ padding: '3px'}}>{row.totalamount.toFixed(2)}</TableCell> */}
                                    <TableCell sx={{ padding: '3px' }}>{row.Remark}</TableCell>
                                    <TableCell sx={{ padding: '3px', textAlign: 'right' }}> {(row.totalamount ?? 0).toFixed(2)}</TableCell>

                                </TableRow>
                            ))}
                        </TableBody>

                    </Table>
                </TableContainer>
            </div>

            <Dialog open={confirmDialogOpen} onClose={closeConfirmDialog}>
                <DialogTitle>Delete Confirmation</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeConfirmDialog} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDelete} color="secondary">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default SaleReturnReport;